import { css } from 'lit';

export const styles = css`
  :host {
    display: block;
  }

  .profile-page {
    max-width: 1000px;
    margin: 0 auto;
    padding: 2rem;
    background: var(--sl-color-neutral-0);
    min-height: 100vh;
  }

  .loading-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 4rem;
    gap: 1rem;
  }

  .profile-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 2rem;
    padding-bottom: 1rem;
    border-bottom: 1px solid var(--sl-color-neutral-200);
  }

  .back-button {
    margin-bottom: 1rem;
  }

  .profile-title h1 {
    margin: 0 0 0.5rem 0;
    font-size: 2rem;
    font-weight: 600;
    color: var(--sl-color-neutral-800);
  }

  .profile-title p {
    margin: 0;
    color: var(--sl-color-neutral-600);
    font-size: 1rem;
  }

  .profile-content {
    display: flex;
    flex-direction: column;
    gap: 2rem;
  }

  .error-message {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 1rem;
    background: var(--sl-color-danger-50);
    color: var(--sl-color-danger-700);
    border: 1px solid var(--sl-color-danger-200);
    border-radius: var(--sl-border-radius-medium);
    font-size: 0.875rem;
  }

  .success-message {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 1rem;
    background: var(--sl-color-success-50);
    color: var(--sl-color-success-700);
    border: 1px solid var(--sl-color-success-200);
    border-radius: var(--sl-border-radius-medium);
    font-size: 0.875rem;
  }

  .profile-form {
    display: flex;
    flex-direction: column;
    gap: 2rem;
  }

  .form-section {
    background: var(--sl-color-neutral-0);
    border: 1px solid var(--sl-color-neutral-200);
    border-radius: var(--sl-border-radius-large);
    padding: 1.5rem;
  }

  .form-section h3 {
    margin: 0 0 1.5rem 0;
    font-size: 1.25rem;
    font-weight: 600;
    color: var(--sl-color-neutral-800);
  }

  .form-group {
    margin-bottom: 1.5rem;
  }

  .form-group:last-child {
    margin-bottom: 0;
  }

  .form-group label {
    display: block;
    margin-bottom: 0.5rem;
    font-weight: 500;
    color: var(--sl-color-neutral-700);
    font-size: 0.875rem;
  }

  .error-message {
    margin-top: 0.25rem;
    font-size: 0.75rem;
    color: var(--sl-color-danger-600);
  }

  .help-text {
    margin-top: 0.25rem;
    font-size: 0.75rem;
    color: var(--sl-color-neutral-500);
  }

  .info-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.75rem 0;
    border-bottom: 1px solid var(--sl-color-neutral-100);
  }

  .info-row:last-child {
    border-bottom: none;
  }

  .info-label {
    font-weight: 500;
    color: var(--sl-color-neutral-700);
    font-size: 0.875rem;
  }

  .info-value {
    color: var(--sl-color-neutral-600);
    font-size: 0.875rem;
  }

  .user-id {
    font-family: monospace;
    font-size: 0.75rem;
    background: var(--sl-color-neutral-100);
    padding: 0.25rem 0.5rem;
    border-radius: var(--sl-border-radius-small);
  }

  .address-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
  }

  /* Tab group styling */
  sl-tab-group {
    margin-top: 1rem;
  }

  sl-tab-panel {
    padding: 1.5rem 0;
  }

  .account-info {
    display: flex;
    flex-direction: column;
    gap: 2rem;
  }

  .action-buttons {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .action-buttons sl-button {
    justify-content: flex-start;
  }

  .profile-actions {
    display: flex;
    gap: 1rem;
    justify-content: flex-end;
    padding-top: 1rem;
    border-top: 1px solid var(--sl-color-neutral-200);
  }

  /* Form validation styles */
  sl-input[invalid] {
    --sl-input-border-color: var(--sl-color-danger-600);
  }

  /* Responsive design */
  @media (max-width: 768px) {
    .profile-page {
      padding: 1rem;
    }

    .profile-header {
      flex-direction: column;
      gap: 1rem;
      align-items: flex-start;
    }

    .profile-title h1 {
      font-size: 1.5rem;
    }

    .form-section {
      padding: 1rem;
    }

    .profile-actions {
      flex-direction: column-reverse;
    }

    .info-row {
      flex-direction: column;
      align-items: flex-start;
      gap: 0.25rem;
    }

    .address-row {
      grid-template-columns: 1fr;
      gap: 0.5rem;
    }
  }

  @media (max-width: 480px) {
    .profile-page {
      padding: 0.5rem;
    }

    .form-section {
      padding: 0.75rem;
    }
  }
`;
